import { Module } from '@nestjs/common';
import { ComplaintsController } from './complaints.controller';
import { ComplaintsService } from './complaints.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ComplaintsAdapter } from './dto/complaints.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ComplaintsEntity } from './complaints.entity';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([ComplaintsEntity]),
  ],
  controllers: [ComplaintsController],
  providers: [ComplaintsService, ComplaintsAdapter, ApplicationExceptionHandler,LogsService],
  exports: [ComplaintsService]
})
export class ComplaintsModule {}
